/**
 * abilityVfxSett — Sett Q/W/E/R pit-fighter silhouettes (SPY-32).
 */
export function buildKnuckleDown(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.5 * (spec.scale || 1.3);
  const orange = mat(THREE, spec.color || 0xf97316, 0.9);
  const amber = mat(THREE, 0xfbbf24, 0.92);
  addDualFists(THREE, group, s, orange, amber);
  addFootRing(THREE, group, s, orange);
  group.userData = { shape: 'knuckle_down' };
  return group;
}

export function buildHaymaker(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.2);
  const orange = mat(THREE, spec.color || 0xea580c, 0.92);
  const white = mat(THREE, 0xffedd5, 0.95);
  addTruePunch(THREE, group, s, orange, white);
  group.userData = { shape: 'haymaker' };
  return group;
}

export function buildFacebreaker(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.5);
  const amber = mat(THREE, spec.color || 0xfb923c, 0.9);
  const dark = mat(THREE, 0x9a3412, 0.88);
  addClapArms(THREE, group, s, amber, dark);
  addShockRing(THREE, group, s, amber);
  group.userData = { shape: 'facebreaker' };
  return group;
}

export function buildShowStopper(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 2.2);
  const dark = mat(THREE, spec.color || 0xc2410c, 0.9);
  const amber = mat(THREE, 0xf97316, 0.92);
  addSlamPillar(THREE, group, s, dark, amber);
  addCrater(THREE, group, s, dark, amber);
  group.userData = { shape: 'show_stopper' };
  return group;
}

function addDualFists(THREE, group, s, orange, amber) {
  for (let i = 0; i < 2; i += 1) {
    const fist = new THREE.Mesh(new THREE.BoxGeometry(0.28 * s, 0.28 * s, 0.35 * s), orange);
    fist.position.set((i === 0 ? -1 : 1) * 0.4 * s, 0.7 * s, 0);
    group.add(fist);
    const knuckle = new THREE.Mesh(new THREE.SphereGeometry(0.08 * s, 6, 6), amber);
    knuckle.position.set((i === 0 ? -1 : 1) * 0.4 * s, 0.75 * s, 0.2 * s);
    group.add(knuckle);
  }
}

function addFootRing(THREE, group, s, orange) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.4, s * 0.95, 18).rotateX(-Math.PI / 2),
    orange
  );
  ring.position.y = 0.05;
  group.add(ring);
}

function addTruePunch(THREE, group, s, orange, white) {
  const fist = new THREE.Mesh(new THREE.BoxGeometry(0.4 * s, 0.4 * s, 0.5 * s), orange);
  fist.position.set(0, 0.35 * s, 0.2 * s);
  group.add(fist);
  const beam = new THREE.Mesh(
    new THREE.BoxGeometry(0.55 * s, 0.12 * s, 1.1 * s),
    white
  );
  beam.position.set(0, 0.35 * s, 0.7 * s);
  group.add(beam);
  for (let i = -1; i <= 1; i += 1) {
    const spark = new THREE.Mesh(new THREE.SphereGeometry(0.08 * s, 6, 6), white);
    spark.position.set(i * 0.22 * s, 0.4 * s, 1.2 * s);
    group.add(spark);
  }
}

function addClapArms(THREE, group, s, amber, dark) {
  for (let i = 0; i < 2; i += 1) {
    const arm = new THREE.Mesh(new THREE.BoxGeometry(0.55 * s, 0.14 * s, 0.18 * s), dark);
    arm.position.set((i === 0 ? -1 : 1) * 0.45 * s, 0.55 * s, 0);
    group.add(arm);
    const hand = new THREE.Mesh(new THREE.BoxGeometry(0.22 * s, 0.22 * s, 0.22 * s), amber);
    hand.position.set((i === 0 ? -1 : 1) * 0.15 * s, 0.55 * s, 0);
    group.add(hand);
  }
}

function addShockRing(THREE, group, s, amber) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.25, s * 0.75, 20).rotateX(-Math.PI / 2),
    amber
  );
  ring.position.y = 0.05;
  group.add(ring);
}

function addSlamPillar(THREE, group, s, dark, amber) {
  const body = new THREE.Mesh(new THREE.CylinderGeometry(0.2 * s, 0.35 * s, 1.6 * s, 10), dark);
  body.position.y = 0.9 * s;
  group.add(body);
  const glow = new THREE.Mesh(new THREE.SphereGeometry(0.28 * s, 10, 10), amber);
  glow.position.y = 1.7 * s;
  group.add(glow);
}

function addCrater(THREE, group, s, dark, amber) {
  const outer = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.45, s * 1.05, 26).rotateX(-Math.PI / 2),
    dark
  );
  outer.position.y = 0.04;
  group.add(outer);
  const inner = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.15, s * 0.4, 18).rotateX(-Math.PI / 2),
    amber
  );
  inner.position.y = 0.06;
  group.add(inner);
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
